import React, { useEffect, useState } from 'react'
import Home from '../Home/Home'
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import { useGlobalContext } from '../LoginPage/GlobalContext';
import "../dataTable.css";
const api_url = process.env.REACT_APP_API_URL;

const EditClientComplaintRow = () => {

    const {  clientComplaintRowId,setClientComplaintRowId } = useGlobalContext();

    const [message, setMessage] = useState("")
    const navigate = useNavigate();

    const [complaintRowDetails, setComplaintRowDetails] = useState({});

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     console.log("name", name, value)
    //     setComplaintRowDetails((prevData) => ({
    //         ...prevData,
    //         [name]: value,
    //     }));
    // };

    // ___________________________________________________user Authentication____________________
  useEffect(() => {
    fetch(`${api_url}/getuser`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const userObject = data.find((user) => user._id === sessionStorage.userId);
        // setIsValidUser(userObject.active);
        if (!userObject.active) {
          navigate('/')
        } 
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
// ____________________________________________________________________________________________

    const handleGoBack = () => {
        navigate("/ClientComplaintRow")
    }
    const [adminName,setAdminName] = useState(() =>
    sessionStorage.getItem("displayName"));

    // useEffect(()=>{
    //     setAdminName(() => sessionStorage.getItem("displayName"));
    // },[])

    const handleSubmit = async (e) => {
        e.preventDefault();
       
        try {
        //   const payload = {
        //     ReceivedFrom: complaintRowDetails.ReceivedFrom,
        //     CarriedFromPrevMonth: complaintRowDetails.CarriedFromPrevMonth,
        //     Received: complaintRowDetails.Received,
        //     Resolved: complaintRowDetails.CarriedFromPrevMonth,
        //     Pending: complaintRowDetails.CarriedFromPrevMonth,
        //     // createdBy: complaintRowDetails.createdBy,
        //     updatedBy: complaintRowDetails.updatedBy,
        //   };
        const data = new FormData(e.currentTarget);
        const payload = {
            ReceivedFrom: data.get("receivedFrom"),
            PendingAtTheEndOfMonth: data.get("PendingATEOM"),
            Received: data.get("received"),
            Resolved: data.get("Resolved"),
            TotalPending: data.get("TotalPending"),
            PendingMoreThanThreeMonths: data.get("PendingMoreThanThreeMonths"),
            AverageResolutionTime: data.get("AverageResolutionTime"),
            createdBy: complaintRowDetails.createdBy,
            updatedBy: adminName,
        };

        //   console.log(payload, JSON.stringify(payload));

          const response = await fetch(
            `${api_url}/editClientComplaintRowById/${clientComplaintRowId}`,
            {
              method: "PUT",
              body: JSON.stringify(payload),
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const responseData = await response.json();
          if (responseData) {
            setMessage("Data submitted successfully");
            navigate("/ClientComplaintRow");
          }
        } catch (error) {
          setMessage("Failed to submit Data");
          console.error("Error", error);
        }
    };

    const fetchData = async () => {
        try {
            const response = await fetch(
                `${api_url}/showClientComplaintRowById/${clientComplaintRowId}`
            );
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const result = await response.json();
            //   console.log("result",result);
            setComplaintRowDetails(result);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    return (
        <div>
            <Home />
            <div className="form-container">
                <div className="form-align">
                    <Form onSubmit={handleSubmit} encType="multipart/form-data">
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="examplePassword">Received From</Label>
                                    <Input
                                        placeholder=" Enter here"
                                        type="text"
                                        name="receivedFrom"
                                        required='true'
                                        defaultValue={complaintRowDetails.ReceivedFrom}

                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="examplePassword">Pending At The End Of Month</Label>
                                    <Input
                                        placeholder=" Enter here"
                                        type="text"
                                        name="PendingATEOM"
                                        required='true'
                                        max={100}
                                        defaultValue={complaintRowDetails.PendingAtTheEndOfMonth}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="examplePassword"> Received </Label>
                                    <Input
                                        placeholder=" Enter here"
                                        type="text"
                                        name="received"
                                        required='true'
                                        defaultValue={complaintRowDetails.Received}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="examplePassword"> Resolved </Label>
                                    <Input
                                        placeholder=" Enter here"
                                        type="text"
                                        name="Resolved"
                                        required='true'
                                        defaultValue={complaintRowDetails.Resolved}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="examplePassword"> Total Pending </Label>
                                    <Input
                                        placeholder=" Enter here"
                                        type="text"
                                        name="TotalPending"
                                        required='true'
                                        defaultValue={complaintRowDetails.TotalPending}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="examplePassword"> Pending From More Than Three Months </Label>
                                    <Input
                                        placeholder=" Enter here"
                                        type="text"
                                        name="PendingMoreThanThreeMonths"
                                        required='true'
                                        defaultValue={complaintRowDetails.PendingMoreThanThreeMonths}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="examplePassword"> Average Resolution Time </Label>
                                    <Input
                                        placeholder=" Enter here"
                                        type="text"
                                        name="AverageResolutionTime"
                                        required='true'
                                        defaultValue={complaintRowDetails.AverageResolutionTime}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="examplePassword"> Created By </Label>
                                    <Input
                                        placeholder=" Enter here"
                                        type="text"
                                        name="createdBy"
                                        required='true'
                                        disabled
                                        Value={complaintRowDetails.createdBy}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="examplePassword"> Updated By </Label>
                                    <Input
                                        placeholder=" Enter here"
                                        type="text"
                                        name="updatedBy"
                                        required='true'
                                        disabled
                                        value={adminName}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col md={4}></Col>
                            <Col md={2} className="d-flex justify-content-center">
                                <button
                                    className="btn btn-success"
                                    style={{
                                        backgroundColor: "#259D90",
                                        border: "1px solid lightgray",
                                    }}
                                    onClick={handleGoBack}
                                >
                                    Go Back
                                </button>
                                <br />
                            </Col>
                            <Col md={2} className="d-flex justify-content-center">
                                <button
                                    className="btn btn-success"
                                    type="submit"
                                    style={{
                                        backgroundColor: "#259D90",
                                        border: "1px solid lightgray",
                                    }}
                                >
                                    Submit
                                </button>
                                <br />
                            </Col>
                        </Row>
                        <Col md={4}>

                            <p>{message}</p>
                        </Col>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default EditClientComplaintRow